import { memo, useCallback } from 'react';
import { useAddGuestsStatic } from './AddGuestsContext';
import { confirmModal } from '../../modals';
import { translate } from '../../utils';
import Button from '../Button';

export const AddGuestsContentHeader = memo(function AddGuestsContentHeader({ dirty, isSubmitting }) {
    const { backUrl, roomsCount } = useAddGuestsStatic();

    const handleBackClick = useCallback(async (event) => {
        if (!dirty) {
            return;
        }

        event.preventDefault();
        const choice = await confirmModal(
            translate('frontend', 'ADD_GUESTS_BACK_CONFIRM_TITLE'),
            translate('frontend', 'ADD_GUESTS_BACK_CONFIRM_MESSAGE')
        );

        if (choice === 'confirm') {
            window.location.href = backUrl;
        }
    }, [backUrl, dirty]);

    return (
        <section className="content-header">
            <h1>{translate('frontend', 'ADD_GUESTS_TITLE')}</h1>

            <div className="btn-ribbon">
                <a href={backUrl} className="btn btn-default-clear" onClick={handleBackClick}>
                    {translate('frontend', 'BACK')}
                </a>

                {roomsCount > 0 && (
                    <Button type="submit" form="addGuestsFormId" className="btn btn-primary" loading={isSubmitting} disabled={isSubmitting}>
                        {translate('frontend', 'SAVE_BUTTON')}
                    </Button>
                )}
            </div>
        </section>
    );
});
